/**
 * pdfDetector.js
 * Client-Side PDF Detection & Viewer Resolver
 */

/**
 * Detects whether a URL points to a PDF document.
 */
export function isPdfUrl(url) {
  if (!url || typeof url !== 'string') return false;

  try {
    const parsed = new URL(url);
    const pathname = parsed.pathname.toLowerCase();

    // Direct .pdf file extension
    if (pathname.endsWith('.pdf')) return true;

    // ArXiv PDF link format: arxiv.org/pdf/xxxx.xxxx
    if (parsed.hostname.includes('arxiv.org') && pathname.includes('/pdf/')) return true;

    // Common PDF query param indicators
    if (parsed.searchParams.get('format') === 'pdf' || parsed.searchParams.get('type') === 'pdf') {
      return true;
    }

    return false;
  } catch (e) {
    return url.toLowerCase().includes('.pdf');
  }
}

/**
 * Prepares the URL for browser embedding with standard PDF toolbar flags.
 */
export function getPdfViewerUrl(url) {
  if (!url) return '';
  // Avoid duplicating hash params if already present
  if (url.includes('#')) return url;
  return `${url}#toolbar=1&view=FitH`;
}
